import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.0685 13.1831C13.8245 12.939 13.4289 12.939 13.1849 13.1831C12.941 13.4273 12.941 13.8232 13.1849 14.0673L19.1175 20.0043L13.1913 25.9349C12.9473 26.1791 12.9473 26.5749 13.1913 26.8191C13.4352 27.0633 13.8308 27.0633 14.0748 26.8191L20.001 20.8885L25.9272 26.8191C26.1712 27.0633 26.5668 27.0633 26.8108 26.8191C27.0548 26.5749 27.0548 26.1791 26.8108 25.9349L20.8846 20.0043L26.8171 14.0673C27.0611 13.8232 27.0611 13.4273 26.8171 13.1831C26.5731 12.939 26.1775 12.939 25.9335 13.1831L20.001 19.1201L14.0685 13.1831Z",
		fill: "#333333"
	})
});
export default SvgCross;
